export default "__VITE_ASSET__Cnojm6x8__"